// extracted by mini-css-extract-plugin
module.exports = {"Inner":"Inner__11tG2","grid":"grid__1TwKc"};